export const inputHelpers = {
    methods: {
        /**
         * On tooltip item mouse over
         * @param description
         * @param isRequired
         */
        formattedLabel(description, isRequired) {
            const requiredText = isRequired
                ? `*`
                : '';
            return `${requiredText} ${description}`;
        },
        /**
         * On tooltip item mouse over
         * @param description
         * @param isRequired
         */
        formattedAriaLabel(description, isRequired) {
            const requiredText = isRequired
                ? `(${this.$t('form.required')})`
                : `(${this.$t('form.optional')})`;
            return `${requiredText}: ${description}`;
        },
    },
};
